<template>
  <div class="publish-dynamic">
    <div class="publish-cont">
      <label>标题</label>
      <input type="text" v-model="title" placeholder="请输入标题，为了更好的展示效果，建议标题字数在30字以内，每日上限为3次。" />
    </div>
    <div
      v-show="loading"
      v-loading="loading"
      :element-loading-text="loadNum"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.2)"
      :data="videoUrl"
      class="loading"
      style
    ></div>
    <div class="publish-cont">
      <label>视频上传</label>
      <input type="file" id="input" @change="ossUpload($event)" />
      <label style="text-align:center;" class="upload-video" for="input">点击上传</label>
      <span class="limit">视频不超过500M</span>
      <div class="video-img">
		  <video id="video" :src="videoUrl" :poster="coverImg" controls disablePictureInPicture=false controlslist="nodownload noplaybackrate noremoteplayback"></video>
        <!-- <img :src="coverImg" alt /> -->
      </div>
    </div>
    <div class="publish-cont intro">
      <label>视频描述</label>
      <textarea v-model="content" placeholder="请输入您要发布的内容..."></textarea>
    </div>
    <div class="save-btn">
      <div class="btn-list active" @click="senseWord">发布</div>
      <!-- <div class="btn-list">保存草稿</div>
      <div class="btn-list">客户端浏览</div>-->
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import axios from "axios";
import { log } from "util";
export default {
  // name: "App",
  data() {
    return {
      title: "",
      coverImg: require("../../assets/img/cover.png"),
      loadNum: "",
      content: "",
      videoUrl: "", //https://joingolf.oss-cn-guangzhou.aliyuncs.com/mp4/mda-kfe2yfi24w1ja6a0.mp4
      se: [],
      sensi: [],
      keys: [],
      loading: false,
      editor: null,
      duration: "",
	  videoWidth: '',
	  videoHeight: '',
	  videoSize: '',
	  videoName: '',
      number: 0,
    };
  },
  mounted() {
    this.getList();
    this.getPublishSum();
  },
  methods: {
    getPublishSum() {
      this.$http
        .get("/api/media/015-getPublishSum", {
          params: {
            token: this.$store.state.userInfo.token
          }
        })
        .then(res => {
          if (res.data.code == 0) {
            this.number = res.data.rows[0].videoCount;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getList() {
      //获取专题、专题项、文章分类列表
      this.$http
        .get("/api/media/002-newsAdd", {
          params: {
            id: -1,
            type: 2,
            token: this.$store.state.userInfo.token
          }
        })
        .then(res => {
          if (res.status == 200) {
            this.ztList = res.data.zhuanTiList;
            this.ztxList = res.data.zhuanTiItemList;
            this.flList = res.data.categoryList;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
	// oss直传
	ossUpload(e) {
		var that = this;
		if (that.number >= 3) {
			this.$message("发布视频,每日上限为3次哦~");
			return false;
		}
		that.loading = true;
		// 获取三方配置信息
		axios.post("https://admin.jzda001.com/tools/queryOSSMsg")
			.then(res => {
				if (res.data) {
					// 执行上传
					let file = e.target.files[0];
					let filename = file.name;
					let fileSize = file.size; // b
					let ossData = res.data;
					let formData = new FormData();
					let key = ossData.dir + filename;
					let config = {
						headers: { "Content-Type": "multipart/form-data" },
						onUploadProgress: function(e) {
							if (e.lengthComputable) {
								var progress = parseInt((e.loaded / e.total) * 100);
								that.loadNum = "已加载" + progress + "%";
							}
						}
					};
					// 判断上传的视频是否超过500M 
					if (fileSize > 500 * 1024 * 1024 ) {
						that.loading = false;
						this.$message("视频大小不得超过500M");
						return false;
					}
					that.videoName = filename;
					that.videoSize = ((fileSize / 1024 / 1024).toFixed(2)) + 'MiB';
					// 获取视频信息
					let element = document.createElement('video');
					element.src = URL.createObjectURL(file);
					element.addEventListener('loadedmetadata', () => {
						// 此处执行有延迟  如果在外边打印下面三个参数  需要延迟打印
						let duration = element.duration; // 单位：s
						let hour = '';
						let mon = '';
						let sec = '';
						sec = Math.ceil(duration % 60);
						mon = Math.floor(duration / 60);
						hour = Math.floor(duration / 3600);
						sec = sec < 10 ? '0' + sec : sec;
						mon = mon < 10 ? '0' + mon : mon;
						hour = hour < 10 ? '0' + hour : hour;
						duration = hour + ':' + mon + ':' + sec;
			
						that.duration = duration; 
						that.videoWidth = element.videoWidth; // 宽度
						that.videoHeight = element.videoHeight; // 高度
					})
	
					formData.append('OSSAccessKeyId', ossData.accessKeyId);
					formData.append('policy', ossData.policy);
					formData.append('signature', ossData.signature);
					formData.append('Filename', filename);
					formData.append('key', ossData.dir + filename);
					formData.append('success_action_status', '200');
					formData.append('file', file);
					
					axios.post(ossData.host, formData, config)
						.then(res => {
							if (res.status == 200) {
								that.loading = false;
								that.coverImg = ossData.host + '/' + ossData.dir + filename + '?x-oss-process=video/snapshot,t_1000,m_fast,f_jpg';
								that.videoUrl = ossData.host + '/' + ossData.dir + filename;
							}
						});
				} else {
					this.$message("获取上传配置信息失败");
				}
			});
	},
	// 原先的后台上传接口
    getFile(e) {
      this.loading = true;
      var that = this;
      let param = new FormData();
	  let file = e.target.files[0];
	  let filename = file.name;
	  let fileSize = file.size; // b
	  
	  // 判断上传的视频是否超过500M
	  if (fileSize > 500 * 1024 * 1024 ) {
	  	that.loading = false;
	  	this.$message("视频大小不得超过500M");
	  	return false;
	  }
	  			
      param.append("file", file);
      var config = {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: function(e) {
			if (e.lengthComputable) {
				var progress = parseInt((e.loaded / e.total) * 100);
				that.loadNum = "已加载" + progress + "%";
			}
        }
      };

      axios.post("https://admin.jzda001.com/tools/uploadMp4ForJson", param, config)
        .then(res => {
			console.log(res);
			if (res.status == 200) {
				this.coverImg = res.data.shotPath;
				this.videoUrl = res.data.url;
				this.duration = res.data.duration;
				this.loading = false;
			}
        });
    },
    senseWord() {
		var that = this;
		if (that.number >= 3) {
			this.$message("发布视频,每日上限为3次哦~");
			return false;
		}
		// 将上传的视频信息同步给后端
		axios.post("https://admin.jzda001.com/tools/saveCusVideo", {
			fileName: that.videoName,
			coverImg: that.coverImg,
			url: that.videoUrl,
			size: that.videoSize,
			width: that.videoWidth,
			height: that.videoHeight,
			time: that.duration,
		})
	  	.then(res => {
	  		if (res) {
				// 同步成功之后 执行发布
	  			// 敏感词汇
	  			that.se = [];
	  			that.sensi = [];
	  			that.keys = [];
	  			this.$http
	  			  .get("/api/media/012--sensitivewordList", {
	  			    params: {
	  			      token: this.$store.state.userInfo.token
	  			    }
	  			  })
	  			  .then(res => {
	  			    if (res.data.code == 0) {
	  			      var self = this;
	  			      $.each(res.data.rows, function(k, v) {
	  			        self.se.push(self.title.indexOf(v.keyWord));
	  			        self.sensi.push(self.content.indexOf(v.keyWord));
	  			      });
	  			      if (self.se.indexOf(0) != -1 || self.sensi.indexOf(0) != -1) {
	  			        this.$message("很抱歉,您发布的内容含有敏感词汇,无法上传");
	  			      } else {
	  			        this.pub();
	  			      }
	  			    }
	  			  })
	  			  .catch(err => {
	  			    console.log(err);
	  			  });
	  		}
	  	})
	    .catch(err => {
			console.log(err);
	    });
    },
    pub() {
      //发布
      if (this.title == "") {
        this.$message("标题不能为空");
        return false;
      }
      if (this.videoUrl == "") {
        this.$message("视频不能为空");
        return false;
      }
      if (this.content == "") {
        this.$message("视频描述不能为空");
        return false;
      }
      this.$http
        .post("/api/media/003-newsSave", {
          type: 2,
          title: this.title,
          pic: this.coverImg,
          videoUrl: this.videoUrl,
          content: this.content,
          videoDuration: this.duration,
          userId: this.$store.state.userInfo.id
        })
        .then(res => {
          // console.log(res, "发布");
          if (res.data.code == 0) {
            this.$parent.num++;
            this.$message("发布成功");
            this.title = "";
            this.coverImg = "";
            this.videoUrl = "";
            this.content = "";
          } else {
            this.$message(res.data.msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style scoped>
#input {
  display: none;
}
.publish .btn-list {
  margin: 0px auto;
  float: none;
}

.kr-layout .kr-layout-main .main-right .kr-layout-content {
  min-height: 0px;
}
.publish .publish-cont {
  padding-left: 30px;
  margin-bottom: 10px;
}
.publish .publish-cont textarea {
  border: none;
  padding: 17px 10px;
  height: 100%;
}
.publish .publish-cont.intro {
  height: 400px;
  position: relative;
}
.publish .publish-cont.intro:after {
  content: "";
  display: block;
  width: 100%;
  height: 1px;
  background: #ededed;
  position: absolute;
  bottom: 0px;
  left: 40px;
  right: 0px;
}
.publish .publish-cont .video-img {
  max-width: 240px;
  max-height: 160px;
  clear: both;
  margin-left: 90px;
  line-height: 0px;
}

.publish .zhuanti {
  padding-left: 40px;
}
.loading {
  width: 200px;
  height: 200px;
  float: left;
  position: absolute;
  left: 50%;
  top: 40%;
  margin: -100px 0px 0px -100px;
}
.publish .publish-cont .upload-video{color:#666}
.publish .publish-cont .video-img{width:240px;height:160px;}
</style>
<style>
.el-loading-spinner i {
  color: #2e8043 !important;
  font-size: 50px !important;
}
.el-loading-mask {
  border-radius: 6px;
}
.el-loading-spinner {
  top: 35% !important;
}
.el-loading-spinner .el-loading-text {
  text-align: center;
  font-size: 16px !important;
  color: #2e8043 !important;
  margin: 15px auto !important;
}
</style>
